import React, { useState } from "react";
import { mediaUrl } from "@/lib/api";
import { Play } from "lucide-react";

// Click-to-load player. Third-party iframe loads only after the user opts in.
export function VideoPlayer({ video, className = "" }) {
  const [active, setActive] = useState(false);
  const thumb = mediaUrl(video.thumbnail);

  return (
    <div className={`relative aspect-video w-full overflow-hidden bg-ink ${className}`} data-testid="video-player">
      {active ? (
        video.provider === "file" ? (
          <video
            src={mediaUrl(video.file_url)}
            poster={thumb || undefined}
            controls
            autoPlay
            playsInline
            className="absolute inset-0 h-full w-full bg-ink"
            data-testid="video-file-player"
          />
        ) : (
          <iframe
            src={`${video.embed_url}${video.embed_url.includes("?") ? "&" : "?"}autoplay=1`}
            title={video.title}
            allow="accelerated-2d-canvas; encrypted-media; picture-in-picture; fullscreen"
            allowFullScreen
            className="absolute inset-0 h-full w-full border-0"
          />
        )
      ) : (
        <button
          onClick={() => setActive(true)}
          className="group absolute inset-0 flex items-center justify-center"
          aria-label={`Play video: ${video.title}`}
          data-testid="video-play-button"
        >
          {thumb ? (
            <img src={thumb} alt={video.title} loading="lazy" className="h-full w-full object-cover opacity-80 transition-opacity group-hover:opacity-95" />
          ) : (
            <div className="h-full w-full bg-gradient-to-br from-ink to-steel-600" />
          )}
          <span className="absolute inset-0 bg-ink/30" />
          <span className="relative flex h-20 w-20 items-center justify-center rounded-full border border-cream-100/40 bg-ink/40 backdrop-blur-md transition-transform duration-300 group-hover:scale-110">
            <Play className="ml-1 h-8 w-8 fill-gold-400 text-gold-400" />
          </span>
        </button>
      )}
    </div>
  );
}
